import React, { forwardRef } from 'react';
import classNames from 'clsx';
import AnimatedIcon from '../../AnimatedIcon/component';
import styles from '../styles/Button.module.scss';
import type { AnimatedIconElementProps, AnimatedSvgRef } from '../Button.types';

const AnimatedButtonIcon = forwardRef<AnimatedSvgRef, AnimatedIconElementProps>(
  ({ svg, duration }, ref) => (
    <AnimatedIcon
      id="animated-icon"
      duration={duration}
      svg={svg}
      className={classNames('animated-icon', styles.icon)}
      ref={ref}
    />
  ),
);

export default AnimatedButtonIcon;
